import { RowDataBanner } from "../../components/BannerPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the BannerTable factory
 */
class BannerRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/banner/read-range"
        this.accessData = "banners"
    }

    create(banner: any): RowDataBanner {
        const rowDataBanner: RowDataBanner = {
            id: banner.id,
            title: banner.title,
            imageSrc: banner.imgSrc,
            websiteRoute: banner.websiteRoute,
            // color: banner.color,
            route: banner.route,
            show: banner.show,
            action: "",
        };
        return rowDataBanner;
    }
}

let bannerRow: BannerRow | null = null;

export default function getBannerRow(): BannerRow {
    if (bannerRow === null)
        bannerRow = new BannerRow()
    return bannerRow
}